import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import rep from "../../assets/images/icons/rep.svg";
import filetextt1 from "../../assets/images/icons/filetextt1.svg";
import { DollarSign, WalletIcon } from "lucide-react";

const ReportLayout = () => {
  const { permissions } = useContext(AppContext);

  const iconStyle = {
    width: "18px",
    height: "18px",
    backgroundColor: "#53b7e8",
    display: "inline-block",
    WebkitMask: `url(${rep}) no-repeat center`,
    mask: `url(${rep}) no-repeat center`,
    WebkitMaskSize: "contain",
    maskSize: "contain",
  };

  const iconStyle1 = {
    width: "18px",
    height: "18px",
    backgroundColor: "#53b7e8",
    display: "inline-block",
    WebkitMask: `url(${filetextt1}) no-repeat center`,
    mask: `url(${filetextt1}) no-repeat center`,
    WebkitMaskSize: "contain",
    maskSize: "contain",
  };

  return (
    <div
      className="content-wrapper"
      style={{
        marginLeft: "250px", // sidebar width
        padding: "20px",
        paddingTop: "80px",
        minHeight: "100vh",
      }}
    >
      {/* Header */}
      <header className="app-header bg-white border-bottom p-3 mb-4 shadow-sm">
        <h1
          style={{
            color: "#000000",
            fontSize: "20px",
            fontWeight: "700",
            margin: 0,
          }}
        >
          Reports
        </h1>
      </header>

      {/* Reports Dashboard */}
      <main className="container-fluid">
        <div className="row g-4">
          {/* --- 1. Inventory Reports --- */}

          {permissions &&
            (permissions["View Sales Executive Report"] ||
              permissions["View Item Wise Sales Report"] ||
              permissions["View Day Wise Sales Report"] ||
              permissions["View Category Wise Report"] ||
              permissions["View Order Summary Report"] ||
              permissions["View Sales VS Material Report"]) && (
              <div className="col-12 col-md-6 col-lg-4">
                <div className="card shadow-sm h-100 border-0">
                  <div
                    className="card-header text-white"
                    style={{ background: "#53b7e8", fontWeight: "600" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide lucide-shelving-unit-icon lucide-shelving-unit"
                    >
                      <path d="M12 12V9a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3" />
                      <path d="M16 20v-3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3" />
                      <path d="M20 22V2" />
                      <path d="M4 12h16" />
                      <path d="M4 20h16" />
                      <path d="M4 2v20" />
                      <path d="M4 4h16" />
                    </svg>{" "}
                    Inventory Reports
                  </div>
                  <ul className="list-group list-group-flush">
                    {/* --- Sub-Modules (Links) with Individual Permission Checks --- */}

                    {permissions["View Sales Executive Report"] && (
                      <Link
                        to="/printList"
                        className="list-group-item list-group-item-action"
                      >
                        <span style={iconStyle} className="me-2"></span>
                        Sales Executive Report
                      </Link>
                    )}

                    {permissions["View Item Wise Sales Report"] && (
                      <Link
                        to="/zamzam-sales-report"
                        className="list-group-item list-group-item-action"
                      >
                        <span style={iconStyle} className="me-2"></span>
                        Item Wise Sales Report
                      </Link>
                    )}

                    {permissions["View Day Wise Sales Report"] && (
                      <Link
                        to="/zamzam-day-wise-report"
                        className="list-group-item list-group-item-action"
                      >
                        <span style={iconStyle} className="me-2"></span>
                        Day Wise Sales Report
                      </Link>
                    )}

                    {permissions["View Category Wise Report"] && (
                      <Link
                        to="/categories-report"
                        className="list-group-item list-group-item-action"
                      >
                        <span style={iconStyle} className="me-2"></span>
                        Category Wise Report
                      </Link>
                    )}

                    {permissions["View Order Summary Report"] && (
                      <Link
                        to="/order-summary-report"
                        className="list-group-item list-group-item-action"
                      >
                        <span style={iconStyle} className="me-2"></span>
                        Order Summary Report
                      </Link>
                    )}

                    {permissions["View Sales VS Material Report"] && (
                      <Link
                        to="/sales-vs-material-report"
                        className="list-group-item list-group-item-action"
                      >
                        <span style={iconStyle} className="me-2"></span>
                        Sales VS Material Report
                      </Link>
                    )}
                  </ul>
                </div>
              </div>
            )}
          {/* --- 2. Account Report --- */}
          {permissions &&
            // Parent Module Check: Saari permissions honi chahiye tabhi Card dikhega
            (permissions["View Profit & Loss"] ||
              permissions["View Balance Sheet"] ||
              permissions["View Trial Balance"] ||
              permissions["View Manual Ledger Form"] ||
              permissions["View ReclassificationTool"]) && (
              <div className="col-12 col-md-6 col-lg-4">
                <div className="card shadow-sm h-100 border-0">
                  <div
                    className="card-header text-white"
                    style={{ background: "#53b7e8", fontWeight: "600" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide lucide-dock-icon lucide-dock"
                    >
                      <path d="M2 8h20" />
                      <rect width="20" height="16" x="2" y="4" rx="2" />
                      <path d="M6 16h12" />
                    </svg>{" "}
                    Account Report
                  </div>
                  <ul className="list-group list-group-flush">
                    {/* Sub-modules par bhi individual checks barkarar hain */}
                    {permissions["View Profit & Loss"] && (
                      <Link
                        to="/ProfitAndLoss"
                        className="list-group-item list-group-item-action"
                      >
                        <span className="me-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#53b7e8"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polyline points="22 17 13.5 8.5 8.5 13.5 2 7"></polyline>
                            <polyline points="16 17 22 17 22 11"></polyline>
                          </svg>
                        </span>
                        Profit & Loss
                      </Link>
                    )}
                    {permissions["View Balance Sheet"] && (
                      <Link
                        to="/BalanceSheet"
                        className="list-group-item list-group-item-action"
                      >
                        <span style={iconStyle1} className="me-2"></span>
                        Balance Sheet
                      </Link>
                    )}
                    {permissions["View Trial Balance"] && (
                      <Link
                        to="/TrialBalance"
                        className="list-group-item list-group-item-action"
                      >
                        <span className="me-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#53b7e8"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <line x1="4" y1="6" x2="20" y2="6"></line>
                            <line x1="8" y1="6" x2="8" y2="20"></line>
                            <line x1="16" y1="6" x2="16" y2="20"></line>
                            <line x1="4" y1="20" x2="20" y2="20"></line>
                            <line x1="10" y1="10" x2="14" y2="10"></line>
                            <line x1="10" y1="14" x2="14" y2="14"></line>
                          </svg>
                        </span>
                        Trial Balance
                      </Link>
                    )}
                    {permissions["View Manual Ledger Form"] && (
                      <Link
                        to="/ManualLedgerForm"
                        className="list-group-item list-group-item-action"
                      >
                        <span className="me-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#53b7e8"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <rect
                              x="3"
                              y="4"
                              width="18"
                              height="16"
                              rx="2"
                            ></rect>
                            <line x1="8" y1="4" x2="8" y2="20"></line>
                            <line x1="10" y1="8" x2="18" y2="8"></line>
                            <line x1="10" y1="12" x2="18" y2="12"></line>
                            <line x1="10" y1="16" x2="18" y2="16"></line>
                            <path d="M14 3l7 7"></path>
                            <path d="M13 7l4 4"></path>
                          </svg>
                        </span>
                        Manual Ledger Form
                      </Link>
                    )}
                    {permissions["View ReclassificationTool"] && (
                      <Link
                        to="/ReclassificationTool"
                        className="list-group-item list-group-item-action"
                      >
                        <span className="me-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#53b7e8"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <rect
                              x="3"
                              y="6"
                              width="6"
                              height="6"
                              rx="1"
                            ></rect>
                            <rect
                              x="15"
                              y="12"
                              width="6"
                              height="6"
                              rx="1"
                            ></rect>
                            <path d="M9 9h6"></path>
                            <polyline points="12 6 15 9 12 12"></polyline>
                            <path d="M15 15H9"></path>
                            <polyline points="12 18 9 15 12 12"></polyline>
                          </svg>
                        </span>
                        Reclassification Tool
                      </Link>
                    )}
                  </ul>
                </div>
              </div>
            )}

          {/* --- 3. CRM --- */}
          {permissions &&
            (permissions["View Phonebook Dashboard"] ||
              permissions["View Office Caller Dashboard"] ||
              permissions["View Call Report"]) && (
              <div className="col-12 col-md-6 col-lg-4">
                <div className="card shadow-sm h-100 border-0">
                  <div
                    className="card-header text-white"
                    style={{ background: "#53b7e8", fontWeight: "600" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide lucide-user-round-cog-icon lucide-user-round-cog"
                    >
                      <path d="m14.305 19.53.923-.382" />
                      <path d="m15.228 16.852-.923-.383" />
                      <path d="m16.852 15.228-.383-.923" />
                      <path d="m16.852 20.772-.383.924" />
                      <path d="m19.148 15.228.383-.923" />
                      <path d="m19.53 21.696-.382-.924" />
                      <path d="M2 21a8 8 0 0 1 10.434-7.62" />
                      <path d="m20.772 16.852.924-.383" />
                      <path d="m20.772 19.148.924.383" />
                      <circle cx="10" cy="8" r="5" />
                      <circle cx="18" cy="18" r="3" />
                    </svg>{" "}
                    CRM
                  </div>
                  <ul className="list-group list-group-flush">
                    {permissions["View Phonebook Dashboard"] && (
                      <Link
                        to="/CRMDashboard"
                        state={{ activeTab: 0 }}
                        className="list-group-item list-group-item-action"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#53b7e8"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-phone-icon lucide-phone"
                        >
                          <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" />
                        </svg>{" "}
                        PhoneBook Dashboard
                      </Link>
                    )}
                    {permissions["View Office Caller Dashboard"] && (
                      <Link
                        to="/CRMDashboard"
                        state={{ activeTab: 1 }}
                        className="list-group-item list-group-item-action"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#53b7e8"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-users-icon lucide-users"
                        >
                          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                          <path d="M16 3.128a4 4 0 0 1 0 7.744" />
                          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                          <circle cx="9" cy="7" r="4" />
                        </svg>{" "}
                        Office Caller Dashboard
                      </Link>
                    )}
                    {permissions["View Call Report"] && (
                      <Link
                        to="/CallReport"
                        className="list-group-item list-group-item-action"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#53b7e8"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-phone-incoming-icon lucide-phone-incoming"
                        >
                          <path d="M16 2v6h6" />
                          <path d="m22 2-6 6" />
                          <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" />
                        </svg>{" "}
                        PhoneBook Call Report
                      </Link>
                    )}
                  </ul>
                </div>
              </div>
            )}

          {/* --- 4. AP & Procurement --- */}
          {permissions?.["View Purchase Report"] && (
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card shadow-sm h-100 border-0">
                <div
                  className="card-header text-white"
                  style={{ background: "#53b7e8", fontWeight: "600" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-receipt-text-icon lucide-receipt-text"
                  >
                    <path d="M13 16H8" />
                    <path d="M14 8H8" />
                    <path d="M16 12H8" />
                    <path d="M4 3a1 1 0 0 1 1-1 1.3 1.3 0 0 1 .7.2l.933.6a1.3 1.3 0 0 0 1.4 0l.934-.6a1.3 1.3 0 0 1 1.4 0l.933.6a1.3 1.3 0 0 0 1.4 0l.933-.6a1.3 1.3 0 0 1 1.4 0l.934.6a1.3 1.3 0 0 0 1.4 0l.933-.6A1.3 1.3 0 0 1 19 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1 1.3 1.3 0 0 1-.7-.2l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.934.6a1.3 1.3 0 0 1-1.4 0l-.933-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-1.4 0l-.934-.6a1.3 1.3 0 0 0-1.4 0l-.933.6a1.3 1.3 0 0 1-.7.2 1 1 0 0 1-1-1z" />
                  </svg>{" "}
                  AP & Procurement
                </div>
                <ul className="list-group list-group-flush">
                  <Link
                    to="/purchaseReport"
                    className="list-group-item list-group-item-action"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#53b7e8"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide lucide-tag-icon lucide-tag"
                    >
                      <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z" />
                      <circle cx="7.5" cy="7.5" r=".5" fill="currentColor" />
                    </svg>{" "}
                    Purchase Report
                  </Link>
                </ul>
              </div>
            </div>
          )}

          {/* --- 5. Project Costing --- */}
          {permissions?.["View Project Cost Report"] && (
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card shadow-sm h-100 border-0">
                <div
                  className="card-header text-white"
                  style={{ background: "#53b7e8", fontWeight: "600" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-calendar-cog-icon lucide-calendar-cog"
                  >
                    <path d="m15.228 16.852-.923-.383" />
                    <path d="m15.228 19.148-.923.383" />
                    <path d="M16 2v4" />
                    <path d="m16.47 14.305.382.923" />
                    <path d="m16.852 20.772-.383.924" />
                    <path d="m19.148 15.228.383-.923" />
                    <path d="m19.53 21.696-.382-.924" />
                    <path d="m20.772 16.852.924-.383" />
                    <path d="m20.772 19.148.924.383" />
                    <path d="M21 10.592V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6" />
                    <path d="M3 10h18" />
                    <path d="M8 2v4" />
                    <circle cx="18" cy="18" r="3" />
                  </svg>{" "}
                  Project Costing
                </div>
                <ul className="list-group list-group-flush">
                  <Link
                    to="/ProjectCostReport"
                    className="list-group-item list-group-item-action"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#53b7e8"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="lucide lucide-file-cog-icon lucide-file-cog"
                    >
                      <path d="M15 8a1 1 0 0 1-1-1V2a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8z" />
                      <path d="M20 8v12a2 2 0 0 1-2 2h-4.182" />
                      <path d="m3.305 19.53.923-.382" />
                      <path d="M4 10.592V4a2 2 0 0 1 2-2h8" />
                      <path d="m4.228 16.852-.924-.383" />
                      <path d="m5.852 15.228-.383-.923" />
                      <path d="m5.852 20.772-.383.924" />
                      <path d="m8.148 15.228.383-.923" />
                      <path d="m8.53 21.696-.382-.924" />
                      <path d="m9.773 16.852.922-.383" />
                      <path d="m9.773 19.148.922.383" />
                      <circle cx="7" cy="18" r="3" />
                    </svg>{" "}
                    Project Cost Report
                  </Link>
                </ul>
              </div>
            </div>
          )}

          {/* --- 6. AR Revenue --- */}
          {permissions?.["View Sales Report"] && (
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card shadow-sm h-100 border-0">
                <div
                  className="card-header text-white"
                  style={{ background: "#53b7e8", fontWeight: "600" }}
                >
                  AR Revenue
                </div>
                <ul className="list-group list-group-flush">
                  <Link
                    to="/salesReport"
                    className="list-group-item list-group-item-action"
                  >
                    Sales Report
                  </Link>
                </ul>
              </div>
            </div>
          )}

          {/* --- Card 1: Chat Bot Admin --- */}
          {permissions?.["View Data Statistics"] && (
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card shadow-sm h-100 border-0">
                <div
                  className="card-header text-white d-flex align-items-center"
                  style={{ background: "#53b7e8", fontWeight: "600" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="me-2"
                  >
                    <path d="M12 6V2H8" />
                    <path d="M15 11v2" />
                    <path d="M2 12h2" />
                    <path d="M20 12h2" />
                    <path d="M20 16a2 2 0 0 1-2 2H8.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 4 20.286V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z" />
                    <path d="M9 11v2" />
                  </svg>
                  Chat Bot Admin
                </div>
                <ul className="list-group list-group-flush">
                  <Link
                    to="/dataStatistics"
                    className="list-group-item list-group-item-action d-flex align-items-center"
                    style={{ padding: "10px 15px" }}
                  >
                    <img
                      src="https://app.wifiattendance.com/static/media/datastat.1e0e437442831f00461b71e2f9024e20.svg"
                      alt="Data Stats"
                      width="18"
                      height="18"
                      className="me-3"
                      style={{
                        filter:
                          "invert(63%) sepia(87%) saturate(351%) hue-rotate(167deg)",
                      }}
                    />
                    <span style={{ fontSize: "14px" }}>Data Statistics</span>
                  </Link>
                </ul>
              </div>
            </div>
          )}

          {/* --- Card 2: Test Management --- */}
          {permissions?.["View Data Statistics"] && (
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card shadow-sm h-100 border-0">
                <div
                  className="card-header text-white d-flex align-items-center"
                  style={{ background: "#53b7e8", fontWeight: "600" }}
                >
                  <img
                    src="https://app.wifiattendance.com/static/media/taskmanag.bff5f45630c2dafc09c07e9fc5966d9f.svg"
                    alt="Test Mgmt"
                    width="18"
                    height="18"
                    className="me-2"
                    style={{ filter: "brightness(0) invert(1)" }}
                  />
                  Test Management
                </div>
                <ul className="list-group list-group-flush">
                  <Link
                    to="/TestDataStatic"
                    className="list-group-item list-group-item-action d-flex align-items-center"
                    style={{ padding: "10px 15px" }}
                  >
                    <img
                      src="https://app.wifiattendance.com/static/media/role.54cf9f4d74d3668a8d8b020d118fba76.svg"
                      alt="Test Data Stats"
                      width="18"
                      height="18"
                      className="me-3"
                      style={{
                        filter:
                          "invert(63%) sepia(87%) saturate(351%) hue-rotate(167deg)",
                      }}
                    />
                    <span style={{ fontSize: "14px" }}>
                      Test Data Statistics
                    </span>
                  </Link>
                </ul>
              </div>
            </div>
          )}

          {/* --- Card 3: Workflow --- */}
          {permissions?.["View Workflow Dashboard"] && (
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card shadow-sm h-100 border-0">
                <div
                  className="card-header text-white d-flex align-items-center"
                  style={{ background: "#53b7e8", fontWeight: "600" }}
                >
                  <img
                    src="https://app.wifiattendance.com/static/media/workflow.a8b3bb489fa22f68260a052101cbacc5.svg"
                    alt="Workflow"
                    width="18"
                    height="18"
                    className="me-2"
                    style={{ filter: "brightness(0) invert(1)" }}
                  />
                  Workflow
                </div>
                <ul className="list-group list-group-flush">
                  <Link
                    to="/workflowDashboard"
                    className="list-group-item list-group-item-action d-flex align-items-center"
                    style={{ padding: "10px 15px" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#53b7e8"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="me-3"
                    >
                      <rect width="8" height="8" x="3" y="3" rx="2" />
                      <path d="M7 11v4a2 2 0 0 0 2 2h4" />
                      <rect width="8" height="8" x="13" y="13" rx="2" />
                    </svg>
                    <span style={{ fontSize: "14px" }}>Workflow Dashboard</span>
                  </Link>
                </ul>
              </div>
            </div>
          )}

          {/* Wallet Repost Start */}

          {/* {permissions?.["View Workflow Dashboard"] && ( */}
          <div className="col-12 col-md-6 col-lg-4">
            <div className="card shadow-sm h-100 border-0">
              <div
                className="card-header text-white d-flex align-items-center"
                style={{ background: "#53b7e8", fontWeight: "600" }}
              >
                <WalletIcon
                  size={18}
                  color="#fff"
                  className="me-3"
                  strokeWidth={2}
                />
                Wallet Report
              </div>
              <ul className="list-group list-group-flush">
                {permissions?.["View Revenue Report"] && (
                <Link
                  to="/wallet/admin/revenue"
                  className="list-group-item list-group-item-action d-flex align-items-center"
                  style={{ padding: "10px 15px" }}
                >
                  <DollarSign
                    size={18}
                    color="#53b7e8"
                    className="me-3"
                    strokeWidth={2}
                  />
                  <span style={{ fontSize: "14px" }}>Revenue Report</span>
                </Link>
                )}
              </ul>
            </div>
          </div>
          {/* )} */}
        </div>
      </main>
    </div>
  );
};

export default ReportLayout;
